module.exports = __webpack_public_path__ + "7c68bf8db234c8c7e27882268531b065.jpg";